import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
//获取服务器，角色列表。根据id返回出来value
import { getGameServerMap, getGameGoodsMap, getUserInfoMap } from "@/utils/dictionary";
export default {
  props: {
    formData: Object,
    openEmailType: Number
  },
  data: function data() {
    return {
      goodList: {},
      serverList: [],
      UserInfoList: {}
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    headStyle: function headStyle() {
      var styleJson = {};
      styleJson = {
        color: "#409EFF"
      };
      return styleJson;
    },
    rowStyle: function rowStyle() {
      var styleJson = {};
      styleJson = {
        color: "#67c23a",
        backgroundColor: "#f0f9eb"
      };
      return styleJson;
    },
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, userInfo;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getGameGoodsMap();
            case 2:
              _this.goodList = _context.sent;
              _context.next = 5;
              return getGameServerMap();
            case 5:
              res = _context.sent;
              _this.serverList = res;
              _context.next = 9;
              return getUserInfoMap();
            case 9:
              userInfo = _context.sent;
              _this.UserInfoList = userInfo;
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};